/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */

export const REPORT_STATUSES = [
  'DRAFT',
  'SUBMITTED',
  'APPROVED',
  'REJECTED',
  'REIMBURSED',
];

/**
 * Chiave di lang string dello stato di una nota. Una nota SUBMITTED che
 * attende la finance ha un'etichetta propria.
 */
export const reportStatusKey = (
  status: string,
  awaitingFinance: boolean,
): string => {
  if (status === 'SUBMITTED' && awaitingFinance) {
    return 'expensa.status_awaiting_finance';
  }
  return `expensa.status_${status.toLowerCase()}`;
};

export const expenseStatusKey = (status: string): string =>
  `expensa.expense_${status.toLowerCase()}`;

export const kindKey = (kind: string): string =>
  `expensa.kind_${kind.toLowerCase()}`;

export const EXPENSE_STATUSES = ['READY', 'NEEDS_REVIEW'];

export const EXPENSE_KINDS = ['RECEIPT', 'MILEAGE', 'PER_DIEM'];

export const EVENT_TYPES = [
  'CREATED',
  'ITEMS_ADDED',
  'ITEM_REMOVED',
  'SUBMITTED',
  'SUPERVISOR_APPROVED',
  'APPROVED',
  'REJECTED',
  'REOPENED',
  'REIMBURSED',
  'COMMENT',
  'PRESERVED',
];

export const eventKey = (type: string): string =>
  `expensa.event_${type.toLowerCase()}`;
